export default "__VITE_ASSET__CigTygkB__"